import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { BookOpen, CheckCircle, Link, Loader } from 'lucide-react'
import ThemeChanger from '../Components/ThemeChanger'
import Bg from '../Components/background/Bg'
import api from '../api'
import { useAuth } from '../Context/AuthContext'

export default function LoadingPageRoadMapCommon() {
  const [currentState, setCurrentState] = useState(null);
  const { roadMapId } = useParams();
  const [progress, setProgress] = useState(0);
  const navigate = useNavigate();
  const { auth } = useAuth()
  const [completed, setCompleted] = useState([false, false, false]);
  const loadingStates = [
    {
      id: 0,
      title: "Generating Topics",
      description: "Generating the Topics You Should Focus On",
      icon: <Loader className="animate-spin" />,
      completedIcon: <CheckCircle />,
      color: "text-blue-500"
    },
    {
      id: 1,
      title: "Generating Subtopics",
      description: "Creating common learning paths",
      icon: <BookOpen />,
      completedIcon: <CheckCircle />,
      color: "text-purple-500"
    },
    {
      id: 2,
      title: "Generating Resource Links",
      description: "Finding the best learning reasources for each subtopic",
      icon: <Link />,
      completedIcon: <CheckCircle />,
      color: "text-green-500"
    }
  ];

  useEffect(() => {
    if (!auth.role || !auth.id) {
      navigate('/login')
    }
  }, [])


  function generateRoadMapPhase1() {
    api.get(`/roadmap/generate-roadmap-common-phase1?roadMapId=${roadMapId}`).then(res => {
      const response = res.data;
      if (response.statusCode === 200) {
        setCurrentState(1)
        setCompleted(prev => [true, false, false])
      } else {
        if (response.statusCode === 401) {
          navigate("/dashboard")
        } else {
          console.log(res)
        }
      }
    })
  }

  function generateRoadMapPhase2() {
    console.log("phase 2 generation start")
    api.get(`/roadmap/generate-roadmap-phase2?roadMapId=${roadMapId}`).then(res => {
      const response = res.data;
      if (response.statusCode === 200) {
        setCurrentState(2)
        setCompleted(prev => [true, true, false])
      } else {
        if (response.statusCode === 401) {
          navigate("/dashboard")
        } else {
          console.log("error in phase 2")
          console.log(res)
        }
      }
    })
  }
  function generateRoadMapPhase3() {
    api.get(`/roadmap/generate-roadmap-phase3?roadMapId=${roadMapId}`).then(res => {
      const response = res.data;
      console.log(response);
      if (response.statusCode === 200) {
        setCompleted(prev => [true, true, true])
        setProgress(100)
      } else {
        if (response.statusCode === 401) {
          navigate("/dashboard")
        } else {
          console.log(res)
        }
      }
    })
  }

  useEffect(() => {
    if (currentState == 0) {
      setCompleted(prev => [true, false, false]);
      generateRoadMapPhase1();
    } else if (currentState == 1) {
      setCompleted(prev => [true, false, false]);
      generateRoadMapPhase2();
      setProgress(33)
    } else if (currentState == 2) {
      setCompleted(prev => [true, true, false]);
      generateRoadMapPhase3();
      setProgress(66)
    }
  }, [currentState]);

  useEffect(() => {
    if (!roadMapId) return
    setCurrentState(0);
    setCompleted(prev => [false, false, false]);
  }, [roadMapId]);

  return (
    <div className="min-h-screen bg-base-200 flex flex-col items-center justify-center p-4 relative">
      <Bg />
      <div className="flex flex-col justify-center items-center w-full max-w-md lg:max-w-lg mx-auto bg-base-100 rounded-xl shadow-sm p-6 absolute z-[10] border border-neutral">
        <h1 className="text-2xl font-bold text-center mb-6">Generating Your Roadmap</h1>
        <div className="absolute top-7 right-4">
          <ThemeChanger />
        </div>
        <div className="w-full bg-base-300 rounded-full h-4 mb-8">
          <div
            className="bg-primary h-4 rounded-full transition-all duration-300"
            style={{ width: `${progress}%` }}
          />
        </div>
        <div className="flex justify-between items-center mb-2 w-full">
          <p className="text-sm font-medium">Progress</p>
          <p className="text-sm font-bold">{Math.round(progress)}%</p>
        </div>
        <div className="flex flex-col w-full space-y-6 mt-8">
          {loadingStates.map((state, index) => (
            <div
              key={state.id}
              className={`
                flex items-start gap-4 p-4 rounded-lg transition-all duration-300 bg-base-100 border border-base-300 shadow-sm
                ${currentState === index ? 'bg-base-200 shadow-md' : ''}
                ${completed[index] ? 'opacity-100' : index > currentState ? 'opacity-50' : 'opacity-100'}
              `}
            >
              <div className={`
                                w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0
                                ${completed[index] ? 'bg-success/20 text-success' :
                  currentState === index ? `bg-primary/20 text-primary animate-pulse` : 'bg-base-300 text-base-content/50'}
                            `}>
                {completed[index] ? state.completedIcon : state.icon}
              </div>

              <div>
                <h3 className="font-medium text-base sm:text-lg">
                  {state.title}
                  {index === currentState && !completed[index] && (
                    <span className="inline-flex ml-2">
                      <span className="animate-bounce">.</span>
                      <span className="animate-bounce" style={{ animationDelay: '0.2s' }}>.</span>
                      <span className="animate-bounce" style={{ animationDelay: '0.4s' }}>.</span>
                    </span>
                  )}
                </h3>
                <p className="text-sm text-base-content/70 mt-1">{state.description}</p>
              </div>
            </div>
          ))}
          {
            progress !== 100 &&
            <div className="mt-8 text-center text-sm text-base-content/70">
              Please don't refresh the page. This may take a minute...
            </div>
          }

          {progress === 100 && (
            <div className="mt-6 flex justify-center">
              <button className="btn btn-primary" onClick={() => navigate(`/roadmap/${roadMapId}`)}>
                View Your Roadmap
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}